import { CustomProperty, CustomPropertyType } from "winslow-core";
import "./AppCustomProperty.css";
import { AppCustomPropertyShort } from "./AppCustomPropertyShort";
import { AppCustomPropertyLong } from "./AppCustomPropertyLong";
import { AppCustomPropertyDropdown } from "./AppCustomPropertyDropdown";
import { AppCustomPropertyCheckboxSingle } from "./AppCustomPropertyCheckboxSingle";
import { AppCustomPropertyCheckboxMultiple } from "./AppCustomPropertyCheckboxMultiple";
import { AppCustomPropertyRadio } from "./AppCustomPropertyRadio";
import { AppCustomPropertyRich } from "./AppCustomPropertyRich";
import { AppCustomPropertyPhone } from "./AppCustomPropertyPhone";
import { AppCustomPropertyNumber } from "./AppCustomPropertyNumber";
import { AppCustomPropertyDate } from "./AppCustomPropertyDate";
import { AppCustomPropertyFile } from "./AppCustomPropertyFile";
import { AppCustomPropertyEmployeeRecord } from "./AppCustomPropertyEmployeeRecord";
import { AppCustomPropertyEmail } from "./AppCustomPropertyEmail";
import { AppCustomPropertyPTOPolicies } from "./AppCustomPropertyPTOPolicies";

type AppCustomPropertyProps = {
    customProperty: CustomProperty;
    data: any;
    disabled?: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomProperty = ({customProperty, data, disabled = false, validate, onChange} : AppCustomPropertyProps) => {

    return (
        <div className="app-custom-property">
           {(() => {
                switch (customProperty.type) {
                    case CustomPropertyType.SHORT:
                        return (
                            <AppCustomPropertyShort
                                key={"cp-short-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.LONG:
                        return (
                            <AppCustomPropertyLong
                                key={"cp-long-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.DATE:
                        return (
                            <AppCustomPropertyDate
                                key={"cp-date-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.NUMBER:
                        return (
                            <AppCustomPropertyNumber
                                key={"cp-number-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.EMAIL:
                        return (
                            <AppCustomPropertyEmail
                                key={"cp-email-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.EMPLOYEE_RECORD:
                        return (
                            <AppCustomPropertyEmployeeRecord
                                key={"cp-employee-record-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled} 
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.PTO_POLICIES:
                        return (
                            <AppCustomPropertyPTOPolicies
                                key={"cp-pto-policies-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );    
                    case CustomPropertyType.DROPDOWN:
                        return (
                            <AppCustomPropertyDropdown
                                key={"cp-dropdown-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.CHECKBOX_MULTIPLE:
                        return (
                            <AppCustomPropertyCheckboxMultiple
                                key={"cp-checkbox-multiple-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.CHECKBOX_SINGLE:
                        return (
                            <AppCustomPropertyCheckboxSingle
                                key={"cp-checkbox-single-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.FILE:
                        return (
                            <AppCustomPropertyFile
                                key={"cp-file-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.PHONE:
                        return (
                            <AppCustomPropertyPhone
                                key={"cp-phone-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.RICH:
                        return (
                            <AppCustomPropertyRich
                                key={"cp-rich-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.RADIO:
                        return (
                            <AppCustomPropertyRadio
                                key={"cp-radio-" + customProperty.label}
                                customProperty={customProperty}
                                data={data}
                                disabled={disabled}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    default:
                        return (
                            <div>
                                Type: {customProperty.type}
                            </div>
                        );
                    }
                }
            )()
            }           
        </div>
    )
}